import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { productWizardActions } from '../../model/store';
import { getFundPhoto, FundPhoto } from './fundDetailsDialogApi';
import { Fund } from 'funds-model';

interface UseFundDetailsDialogPhotoProps {
  fund: Fund;
  isButtonVisible?: boolean;
  isButtonHovered?: boolean;
  isMobile: boolean;
}

export const useFundDetailsDialogPhoto = ({
  fund,
  isButtonVisible,
  isButtonHovered,
  isMobile
}: UseFundDetailsDialogPhotoProps) => {
  const [photo, setPhoto] = useState<FundPhoto | undefined>();
  const dispatch = useDispatch();
  const fetchedFunds = useRef<Set<number>>(new Set());

  useEffect(() => {
    const hasFundPhoto = fund.fundPhoto && fund.fundPhoto.length > 0 && fund.fundPhotoType;
    const isReadyForPhotoApiCall = isMobile ? isButtonVisible : isButtonHovered;
    const alreadyFetched = fetchedFunds.current.has(fund.id);

    if (!hasFundPhoto && fund.idForPhoto && !alreadyFetched && isReadyForPhotoApiCall) {
      fetchedFunds.current.add(fund.id);
      getFundPhoto(fund.idForPhoto).then(res => {
        setPhoto(res);
        dispatch(productWizardActions.setFundPhoto({
          fundId: fund.id,
          fundPhoto: res.photoBase64,
          fundPhotoType: res.photoContentType
        }));
      });
    }
  }, [
    fund.id,
    fund.idForPhoto,
    dispatch,
    isButtonVisible,
    isButtonHovered,
    isMobile,
  ]);

  return photo;
};